import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { isEmpty, map } from "lodash";
import { withTranslation } from "react-i18next"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem
} from "reactstrap"

import primg1 from "../../assets/images/no-img.jpg"
import heart from "../../assets/img/heart.png"
import greenHeart from "../../assets/img/green-heart.png"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getProjects } from "../../store/projects/actions"
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { API_URL } from "helpers/api_url";
import projectIcon from "../../assets/img/project-icon.png"
import favIcon from "../../assets/img/fav-icon.png"
import transIcon from "../../assets/img/transaction-icon.png"
class Project extends Component {
  constructor(props) {
  super(props);
  this.state = {
    selectedStatus: '0',
    projectStatus:[],
  }
}
  componentDidMount() {
    const { onGetProject } = this.props;
    onGetProject(localStorage.getItem('agentId'), localStorage.getItem('userId')); 

    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str = 'Bearer ' + token;
    const agentId = localStorage.getItem('agentId');
    
      // axios.get(`${API_URL}ProjectStatus/allforagent?agentId=${agentId}`, { headers: { Authorization: str } })
      //   .then(res => {
      //     const projectStatus = res.data;
      //     this.setState({ projectStatus });
      //   })

}
handleStatusChange = (event) => {
  this.setState({ selectedStatus: event.target.value });
};
getFilteredProjects = () => {
  const { selectedStatus } = this.state;
  const { projects } = this.props;
  
  console.log("Selected Status:", selectedStatus);
  console.log("Projects:", projects);
  
  return selectedStatus === '0'
    ? projects
    : projects.filter(project => {
        return String(project.projectStatus) === selectedStatus;
      });
};
handelFav = async (project) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
  };
  try {
    const payload = {
      clientId: parseInt(localStorage.getItem('userId')),
      agentId: parseInt(localStorage.getItem('agentId')),
      projectId: project.id,
      favouriteProjectDate: new Date(),
      isActive: true,
    }
    toast.loading("Please wait...");
    const response = await axios.post(
      `${API_URL}ClientBuyerFavouriteProject`,
        payload, 
      { headers }
    );
    if(response.data.success){
      const {onGetProject} = this.props;
      toast.dismiss();
      toast.success('Project Marked as Favourite'); 
      onGetProject(localStorage.getItem('agentId'), localStorage.getItem('userId'));
    }
  } catch (error) {
    console.error("Error posting data:", error);
  }
  }
  render() {
    console.log(localStorage.getItem('authUser'));
    const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { projects } = this.props;
    const groupedProjects = this.getFilteredProjects().reduce((acc, project) => {
      const status = project.projectStatus;
      if (!acc[status]) acc[status] = [];
      acc[status].push(project);
      return acc;
    }, {});
    return (
      <React.Fragment>
         <ToastContainer autoClose={2000} />
         {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <div className="page-content">
          <MetaTags>
            <title>Project | Realty Space</title>
          </MetaTags>
          <Container fluid>
          {/* <Breadcrumbs
              title="Projects"
              breadcrumbItem="Projects"
            /> */}
                <Row className="justify-content-between align-items-center mb-4">
                <Col sm="12">
                  <Nav tabs className="projectTab pref-tab">
                    <NavItem>
                      <Link className="nav-link active" to="/project">
                        <span className="d-flex align-items-center gap-2">
                          All Projects
                          <img src={projectIcon} height={16} />
                        </span>
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="nav-link " to="/my-interests">
                        <span className="d-flex align-items-center gap-2">My Favorites

                           <img src={favIcon} height={16} />
                        </span>
                      </Link>
                    </NavItem>
                    <NavItem>
                      <Link className="nav-link" to="/my-transection">
                         <span className="d-flex align-items-center gap-2">My Transactions

                          <img src={transIcon} height={16} />
                         </span>
                      </Link>
                    </NavItem>
                  </Nav>
                </Col>
              </Row>
             

            {/* <h4 style={{width:'100%', textTransform:'uppercase'}}>All Projects


              <span className="float-end mb-20">
              <select name="status"
               value={this.state.selectedStatus} 
               onChange={this.handleStatusChange} 
              className="form-select">
                          <option value="0">Select Status...</option>
                          {
                            this.state.projectStatus
                              .map(projectStat =>
                                <option key={projectStat.id} value={projectStat.id}>{projectStat.projectStatusTitle}</option>
                              )
                          }
                        </select>

              </span>
            </h4> */}
            <div className="clearfix"></div>


{/* {this.getFilteredProjects().map((project, projectkey) => (
  <Col sm="3" key={"_note_" + projectkey}>
    <div className="product">
      <div className="project-satatus">
          <span>{localization["ProjectStatus_"+ project.projectStatus]}</span>
      </div>
    <Link to={"/project-detail/" + project.id + "/" + project.projectId}>
        <div className="pro-img minHeight">
        {project.projectMainImage != null 
           ? <img src={project?.projectMainImage?.projectGalleryLink} style={{width:300}} className="img-fluid" />
           : <img src={primg1} style={{width:300}} className="img-fluid" />
        }
        </div>
      </Link>
      <div className="bg-transparent border-top card-footer"><div className="contact-links d-flex"><div className="flex-fill font-size-14">{project.city}</div><div className="float-end"><Link to={"/project-detail/" + project.id + "/" + project.projectId}> {project.projectName} </Link></div></div></div>
        
    </div>

  </Col>
))}
  */}

{Object.keys(groupedProjects).map((statusKey) => (
      <div key={statusKey} className="status-section">
        <h4 className="mt-2 mb-3">{localization["ProjectStatus_" + statusKey]}</h4> 
        <Row>
          {groupedProjects[statusKey].map((project, projectkey) => (
            <Col sm="3" key={"_note_" + projectkey}>
              <div className="product">
                {/* <div className="project-satatus">
                  <span>{localization["ProjectStatus_" + project.projectStatus]}</span>
                </div> */}
                  <div className="icon-check">
                    {project.isMarkedFavouriteByClient ? (
                      <img src={greenHeart} style={{width:30, cursor:'pointer'}}  />
                    ) : (
                      <img onClick={()=>this.handelFav(project)} src={heart} style={{width:30, cursor:'pointer'}}  />
                     
                    )}
                   
                    </div>
                <Link to={`/project-detail/${project.id}/${project.preConsProjectGuid}`}>
               
                  <div className="pro-img minHeight">
                  
                    {project.projectMainImage ? (
                      <img src={project?.projectMainImage?.projectGalleryLink} style={{ width: 300 }} className="img-fluid" />
                    ) : (
                      <img src={primg1} style={{ width: 300 }} className="img-fluid" />
                    )}
                  </div>
                </Link>
                <div className="bg-transparent border-top card-footer">
                  <div className="contact-links d-flex">
                    <div className="flex-fill font-size-14">{project.city}</div>
                    <div className="float-end">
                      <Link to={`/project-detail/${project.id}/${project.preConsProjectGuid}`}>
                        {project.projectName}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    ))}






           
            

          </Container>
        </div>
      </React.Fragment>
    )
  }
}
Project.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  onGetProject:PropTypes.func,
  projects:PropTypes.array,
  loading:PropTypes.object
}

const mapStateToProps = ({ projects }) => (
    {
        projects:projects.projects,
        loading:projects.loading
  
    })

    const mapDispatchToProps = dispatch => ({
        
        onGetProject:(agetnId, clientId) => dispatch(getProjects(agetnId, clientId))
       
      });

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Project))
